import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容版块部分
 *
 */



/**
 * 版块查询：列表
 * @param {*} query
 */
export const sectionList = (query) => {
  return request({
    url: `${prefix}/section/list`,
    method: 'get',
    params: query
  })
}

/**
 * 版块查询
 * @param {*} query
 */
export const sectionOne = (query) => {
  return request({
    url: `${prefix}/section`,
    method: 'get',
    params: query
  })
}

/**
 * 版块创建
 * @param {*} query
 */
export const sectionCreate = (query) => {
  return request({
    url: `${prefix}/section`,
    method: 'post',
    data: query
  })
}

/**
 * 版块修改
 * @param {*} query
 */
export const sectionUpdate = (query) => {
  return request({
    url: `${prefix}/section`,
    method: 'put',
    data: query
  })
}

/**
 * 版块删除
 * @param {*} query
 */
export const sectionDestroy = (query) => {
  return request({
    url: `${prefix}/section`,
    method: 'delete',
    data: query
  })
}


/**
 * 版块子项查询：列表
 * @param {*} query
 */
export const sectionItemList = (query) => {
  return request({
    url: `${prefix}/section/item/list`,
    method: 'get',
    params: query
  })
}

/**
 * 版块子项查询
 * @param {*} query
 */
export const sectionItemOne = (query) => {
  return request({
    url: `${prefix}/section/item`,
    method: 'get',
    params: query
  })
}

/**
 * 版块子项创建
 * @param {*} query
 */
export const sectionItemCreate = (query) => {
  return request({
    url: `${prefix}/section/item`,
    method: 'post',
    data: query
  })
}

/**
 * 版块子项修改
 * @param {*} query
 */
export const sectionItemUpdate = (query) => {
  return request({
    url: `${prefix}/section/item`,
    method: 'put',
    data: query
  })
}

/**
 * 版块子项删除
 * @param {*} query
 */
export const sectionItemDestroy = (query) => {
  return request({
    url: `${prefix}/section/item`,
    method: 'delete',
    data: query
  })
}



/**
 * 院校专业版块查询：列表
 * @param {*} query
 */
 export const collegeSectionList = (query) => {
  return request({
    url: `${prefix}/section/college/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校专业版块查询
 * @param {*} query
 */
export const collegeSectionOne = (query) => {
  return request({
    url: `${prefix}/section/college`,
    method: 'get',
    params: query
  })
}

/**
 * 院校专业版块创建
 * @param {*} query
 */
export const collegeSectionCreate = (query) => {
  return request({
    url: `${prefix}/section/college`,
    method: 'post',
    data: query
  })
}

/**
 * 院校专业版块修改
 * @param {*} query
 */
export const collegeSectionUpdate = (query) => {
  return request({
    url: `${prefix}/section/college`,
    method: 'put',
    data: query
  })
}

/**
 * 院校专业版块删除
 * @param {*} query
 */
export const collegeSectionDestroy = (query) => {
  return request({
    url: `${prefix}/section/college`,
    method: 'delete',
    data: query
  })
}

